import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { z } from 'zod';

import { PublicReportDetails } from '@/components/map/PublicReportDetails';
import { I18N_DE } from '@/i18n/de';
import { Format } from '@/modules/Format';
import { makeMetaTitle, META_ROBOTS_NOINDEX } from '@/modules/META';
import { backendApiReportsFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';

const zValidateSearch = z.object({
  details: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_public/meldungen/$reportId')({
  validateSearch: zValidateSearch,

  loader: ({ params: { reportId }, context: { queryClient } }) => {
    queryClient.ensureQueryData(backendApiReportsFindOneOptions({ path: { reportId } }));
  },

  head: async ({
    params: { reportId },
    match: {
      context: { queryClient },
    },
  }) => {
    const report = await queryClient.ensureQueryData(backendApiReportsFindOneOptions({ path: { reportId } }));

    if (!report.category) {
      throw new Error('Missing `report.category`');
    }

    return {
      meta: [
        makeMetaTitle([`${I18N_DE.ReportMainCategory[report.category.mainCategory]}: ${Format.reportTitle(report)}`]),
        META_ROBOTS_NOINDEX,
      ],
    };
  },

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense>
      <PublicReportDetails />
    </Suspense>
  );
}
